<script>
    import Publication from './Publication.svelte'
    export let diagram
</script>

<div class="diagram">
    <img
        src={diagram.svgdoc.meta.download_url}
        onload="SVGInject(this)"
        alt={diagram.title}
    />
    <div class="diagramInfo">
        <h2 class="diagramTitle">
            {diagram.title}
        </h2>
        {@html diagram.description}
        {#each diagram.related_publications as publication}
            <Publication
                color={diagram.color}
                publication={publication.publicationObject}
            />
        {/each}
    </div>
</div>

<style lang="scss">
    @import "../../styles/vars";

    @include respond-to(computer) {
        .diagram {
            padding: 50px 0 30px;
            border-bottom: 2px solid black;
            width: 90vw;
            margin: 0 auto;
        }

        :global( .diagram svg ){
            width: 40%;
            margin: 0 5% 0 0 ;
            display: inline-block;
            background-color: white;
        }

        .diagramInfo {
            width: 49%;
            margin: 0;
            display: inline-block;
            vertical-align: top;

            .diagramTitle {
                font-family: "Ysabeau", Times, Serif;
                margin-top: 0;
            }

            :global(p) {
                font-family: "Ysabeau";
                font-size: 1.2rem;
            }
        }
    }
    @include respond-to(phone) {
        .diagram {
            box-sizing: border-box;
            padding: 30px 0;
            border-bottom: 2px solid black;
            width: 96vw;
            margin: 0 auto;
        }

        :global( .diagram svg ){
            width: 100%;
            margin: 0 5% 0 0 ;
            display: inline-block;
            background-color: white;
        }

        .diagramInfo {
            width: 100%;
            margin: 0;
            display: inline-block;

            .diagramTitle {
                font-family: "Ysabeau", Times, Serif;
                font-size: 1.5rem;
            }

            :global(p) {
                font-family: "Ysabeau";
                font-size: 1.08rem;
                line-height: 1.45rem;
            }
        }
    }
</style>
